import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["productLine", "productLevel"];
let _ = t => t,
  _t;
import { currentOrderedPaidProductLevels, orderedProductLevels } from 'self-service-api/constants/ProductLevels';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import styled from 'styled-components';
import { currentSkuIdForProductSelector, productForSkuIdSelector } from '../../../selectors/ProductsSelectors';
import { useAppSelector } from '../../../reducers';
import { highestPossiblePriceSelector } from '../../../selectors/PricingSelectors';
import ProductLevelSelectionButton from './ProductLevelSelectionButton';
import UnavailableProductLevelButton from './UnavailableProductLevelButton';
import { jsx as _jsx } from "react/jsx-runtime";
const ResponsiveFlex = styled.div.withConfig({
  displayName: "HubProductLevelPicker__ResponsiveFlex",
  componentId: "sc-5td3xi-0"
})(["display:flex;flex-direction:row;", ""], breakpoint.phone(_t || (_t = _`
    flex-direction: column;
  `)));
const ProductLevelSelectionButtonContainer = _ref => {
  let {
      productLine,
      productLevel
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const skuId = useAppSelector(state => currentSkuIdForProductSelector(state, {
    productLine,
    productLevel
  }));
  const apiName = useAppSelector(state => {
    const product = skuId ? productForSkuIdSelector(state, {
      skuId
    }) : null;
    return product === null || product === void 0 ? void 0 : product.apiName;
  });
  const highestPossiblePrice = useAppSelector(state => skuId && highestPossiblePriceSelector(state, {
    productConfigurations: [createProductConfig({
      skuId
    })]
  }));
  if (!skuId || !highestPossiblePrice) return /*#__PURE__*/_jsx(UnavailableProductLevelButton, {});
  const highMonthlyPrice = highestPossiblePrice && highestPossiblePrice.monthly.calculatedPrice;
  return /*#__PURE__*/_jsx(ProductLevelSelectionButton, Object.assign({
    "data-test-id": apiName,
    productLevel: productLevel,
    price: highMonthlyPrice
  }, rest));
};
const HubProductLevelPicker = ({
  productLine,
  ownedProductLevel,
  disabledProductLevel,
  selectedProductLevel,
  required,
  setSelectedProductLevel,
  ariaLabelledById,
  isLoading
}) => {
  return /*#__PURE__*/_jsx(ResponsiveFlex, {
    role: "group",
    "aria-labelledby": ariaLabelledById,
    children: currentOrderedPaidProductLevels.map(productLevel => {
      const isProductLevelSelected = selectedProductLevel === productLevel;
      return /*#__PURE__*/_jsx(ProductLevelSelectionButtonContainer, {
        productLine: productLine,
        productLevel: productLevel,
        selected: isProductLevelSelected,
        disabled: isLoading || orderedProductLevels.indexOf(disabledProductLevel) >= orderedProductLevels.indexOf(productLevel),
        isCurrentPlan: ownedProductLevel === productLevel,
        onClick: () => {
          if (!isProductLevelSelected) {
            setSelectedProductLevel(productLevel);
          } else if (!required) {
            setSelectedProductLevel(null);
          }
        }
      }, productLevel);
    })
  });
};
export default HubProductLevelPicker;